import { UserRoles } from '../../../utils/constants';

export const schoolsPermissions = {
  'schools.newSchool': [UserRoles.Admin],
  'schools.status': [UserRoles.Admin],
  'schools.changePhoto': [UserRoles.Admin, UserRoles.Ogma],
};
